<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong></h2>

<ngx-spinner [zIndex]="100" name="spAudiencia" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">
  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <div class="row" *ngIf="this.data?.idExpediente == undefined &&  data.accion == accionesDialog.Agregar">
        <div class="col">
          <app-buscar-expediente formControlName="IdExpediente"
            (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Lugar</mat-label>
            <input matInput type="text" maxlength="200" formControlName="Lugar" />

            <mat-error *ngIf="f.Lugar.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>

            <mat-error *ngIf="f.Lugar.errors?.maxlength">Superó el largo máximo.</mat-error>

          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Sala</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Sala" />
            <mat-error *ngIf="f.Sala.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTiposAudiencia" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo Audiencia</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="IdTipoAudiencia">
              <mat-option [value]="tipoAudiencia.id" *ngFor="
                  let tipoAudiencia of tiposAudiencia;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ tipoAudiencia.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.IdTipoAudiencia.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>

          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spEstadosAudiencia" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado Audiencia</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="IdEstadoAudiencia">
              <mat-option [value]="estadosAudiencia.id" *ngFor="
                  let estadosAudiencia of estadosAudiencia;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ estadosAudiencia.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.IdEstadoAudiencia.errors?.required">Este campo es
              <strong>requerido</strong>.</mat-error>

          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha</mat-label>
            <input matInput type="datetime-local" formControlName="Fecha" placeholder="MM/DD/YYYY" />

            <mat-error *ngIf="f.Fecha.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
        <div class="col">

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input cdkFocusInitial matInput type="text" maxlength="100" style="text-transform: uppercase"
              formControlName="Descripcion" />
            <mat-error *ngIf="f.Descripcion.errors?.maxlength">Superó el largo máximo.</mat-error>
          </mat-form-field>
        </div>



      </div>


      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>URL/Link Acta</mat-label>
            <input matInput type="text" maxlength="500" formControlName="ActaUrl" />
            <button mat-icon-button matSuffix *ngIf="form.get('ActaUrl')?.value"
              [disabled]="!esUrlValida(form.get('ActaUrl')?.value)" (click)="abrirUrl(form.get('ActaUrl')?.value)"
              matTooltip="Abrir enlace">
              <mat-icon>open_in_new</mat-icon>
            </button>

          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>URL/Link Virtual</mat-label>
            <input matInput type="text" maxlength="500" formControlName="LinkVirtual" />

            <button mat-icon-button matSuffix *ngIf="form.get('LinkVirtual')?.value"
              [disabled]="!esUrlValida(form.get('LinkVirtual')?.value)"
              (click)="abrirUrl(form.get('LinkVirtual')?.value)" matTooltip="Abrir enlace">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Resultado Audiencia</mat-label>
            <input matInput type="text" maxlength="500" formControlName="ResultadoAudiencia" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
          <mat-checkbox formControlName="RequiereActa">
            ¿Requiere Acta?
          </mat-checkbox>
        </div>
        <div class="col-auto">
          <mat-checkbox formControlName="ActaGenerada">
            ¿Acta Generada?
          </mat-checkbox>
        </div>
        <div class="col-auto">
          <mat-checkbox formControlName="Notificado">
            Notificado
          </mat-checkbox>
        </div>
      </div>
      <br>
      <div class="row">
        <mat-form-field appearance="outline" class="w-100" *ngIf="!data.esEliminar; else elseTemplate">
          <mat-label>Observaciones</mat-label>
          <textarea matInput #message name="Observaciones" formControlName="Observaciones"></textarea>
          <mat-hint align="start">Amplie información</mat-hint>
          <mat-hint align="end">{{ message.value.length }} / 200</mat-hint>


          <mat-error *ngIf="f.Observaciones.errors?.maxlength">Supero el largo
            maximo.</mat-error>
        </mat-form-field>
      </div>


    </ng-template>
  </form>

</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="data">
    <!-- Card principal -->
    <div class="row">
      <div class="col">
        <mat-card appearance="outlined">

          <mat-card-header>
            <mat-card-title>Información General</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div>
              <div class="property-row">
                <span class="property-name">Lugar:</span>
                <span class="property-value">{{ data.audiencia?.lugar }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Sala:</span>
                <span class="property-value">{{ data.audiencia?.sala }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Fecha:</span>
                <span class="property-value">{{ data.audiencia?.fecha | date:'short' }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Descripción:</span>
                <span class="property-value">{{ data.audiencia?.descripcion }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Observaciones:</span>
                <span class="property-value">{{ data.audiencia?.observaciones }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col">

        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Estado</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div>
              <div class="property-row">
                <span class="property-name">Tipo de Audiencia:</span>
                <span class="property-value">{{ data.audiencia?.tipoAudiencia?.descripcion }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Estado de Audiencia:</span>
                <span class="property-value">{{ data.audiencia?.estadoAudiencia?.descripcion }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Notificado:</span>
                <span class="property-value">{{ data.audiencia?.notificado ? 'Sí' : 'No' }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Requiere Acta:</span>
                <span class="property-value">{{ data.audiencia?.requiereActa ? 'Sí' : 'No' }}</span>
              </div>
              <div class="property-row" *ngIf="data.audiencia?.actaGenerada">
                <span class="property-name">Acta:</span>
                <span class="property-value">
                  <a [href]="data.audiencia?.actaUrl" target="_blank">Ver Acta</a>
                </span>
              </div>
            </div>
          </mat-card-content></mat-card>
      </div>
    </div>

    <div class="row">
      <div class="col">

        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Asignaciones</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div>
              <div class="property-row">
                <span class="property-name">Asignado A:</span>
                <span class="property-value">{{ data.audiencia?.asignadoA?.nombre }} {{
                  data.audiencia?.asignadoA?.apellido }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Empresa:</span>
                <span class="property-value">{{ data.audiencia?.empresa?.descripcion }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Expediente:</span>
                <span class="property-value">{{ data.audiencia?.expediente?.caratula }}</span>
              </div>
              <div class="property-row" *ngIf="data.audiencia?.linkVirtual">
                <span class="property-name">Link Virtual:</span>
                <span class="property-value">
                  <a [href]="data.audiencia?.linkVirtual" target="_blank">Acceder</a>
                </span>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
      <div class="col"> </div>
    </div>
  </div>


</mat-dialog-content>


<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
